export default __webpack_public_path__ + "static/media/architecture_contrast.db653f69.jpg";